/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   CurrentSearchView reducers
 */

import { alwaysReducer, payloadReducer } from '@zcode/reducers'
import type { CurrentSearchView } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleAction, handleActions } from 'redux-actions'
import {
  BEGIN_SHIMMER,
  CLEAR_TOAST_TYPE,
  FINISH_SHIMMER,
  HIDE_MARKERS,
  RESET_TOGGLE_VALUE,
  SET_FREEZE_BOX,
  SET_SAVED_SEARCH_EMAIL,
  SET_SELECTED_POI_CATEGORY,
  SET_SHOW_NIGHTLY_PRICE,
  SET_TOAST_TYPE,
  SET_TOGGLE_VALUE,
  SHOW_MARKERS,
} from '../constants/index'
import { pinsReducer } from '../modules/pins/reducers/index'
import { CLEAR_ALL_POI } from '../modules/poi/constants/index'
import { poiReducer } from '../modules/poi/reducers/index'
import type { ActionTypes } from './types'

const currentSearchViewReducers = combineReducers<CurrentSearchView, ActionTypes>({
  freezeBox: handleAction<CurrentSearchView['freezeBox'], ActionTypes, typeof SET_FREEZE_BOX>(
    SET_FREEZE_BOX,
    payloadReducer,
    true
  ),
  poi: poiReducer,
  pins: pinsReducer,
  savedSearchEmail: handleAction<
    CurrentSearchView['savedSearchEmail'],
    ActionTypes,
    typeof SET_SAVED_SEARCH_EMAIL
  >(SET_SAVED_SEARCH_EMAIL, payloadReducer, null),
  shimmer: handleActions(
    {
      [BEGIN_SHIMMER]: alwaysReducer(true),
      [FINISH_SHIMMER]: alwaysReducer(false),
    },
    false
  ),
  showMarkers: handleActions(
    {
      [SHOW_MARKERS]: alwaysReducer(true),
      [HIDE_MARKERS]: alwaysReducer(false),
    },
    true
  ),
  showNightlyPrice: handleAction<
    CurrentSearchView['showNightlyPrice'],
    ActionTypes,
    typeof SET_SHOW_NIGHTLY_PRICE
  >(SET_SHOW_NIGHTLY_PRICE, payloadReducer, true),
  selectedPOICategory: handleActions<CurrentSearchView['selectedPOICategory'], ActionTypes>(
    {
      [SET_SELECTED_POI_CATEGORY]: payloadReducer,
      [CLEAR_ALL_POI]: alwaysReducer(null),
    },
    null
  ),
  toastType: handleActions(
    {
      [SET_TOAST_TYPE]: payloadReducer,
      [CLEAR_TOAST_TYPE]: () => '',
    },
    ''
  ),
  toggleValue: handleActions<CurrentSearchView['toggleValue'], ActionTypes>(
    {
      [SET_TOGGLE_VALUE]: payloadReducer,
      [RESET_TOGGLE_VALUE]: () => '',
    },
    'split'
  ),
})

export default currentSearchViewReducers
